// Should stay in sync with directChannelType.mjs
export const DIRECT_CHANNEL_TYPE = {
  NA: 0,
  DC_ATM: 1,
  DC_ATL: 2
};
